const storeName = 'view-elevator-display-routes'
export const routes = {
  namespaced: true,
  state: {
    lastMainRoute: localStorage.getItem(storeName + '-last-main-route')
  },
  mutations: {
    storeLastMainRoute(state, route) {
      state.lastMainRoute = route;
      localStorage.setItem(storeName + '-last-main-route', route ? route : '');
    }
  }
}
